const CalculatorIcon = (props) => {

    return <svg xmlns="http://www.w3.org/2000/svg" 
    enableBackground="new 0 0 24 24" 
    height="24" viewBox="0 0 24 24" 
    width="24" {...props}>
        <g>
            <rect fill="none" height="24" width="24"/>
        </g>
        <g>
            <path d="M19,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M13.03,7.06L14.09,6l1.41,1.41 L16.91,6l1.06,1.06l-1.41,1.41l1.41,1.41l-1.06,1.06L15.5,9.54l-1.41,1.41l-1.06-1.06l1.41-1.41L13.03,7.06z M6.25,7.72h5v1.5h-5 V7.72z M11.5,16h-2v2H8v-2H6v-1.5h2v-2h1.5v2h2V16z M18,17.25h-5v-1.5h5V17.25z M18,14.75h-5v-1.5h5V14.75z"/></g></svg>
}
export default CalculatorIcon;